const getAvatarUrl = (name) => {
  const seed = encodeURIComponent(name || "anonymous");
  return `https://api.dicebear.com/7.x/bottts/svg?seed=${seed}`;
};

export default getAvatarUrl;
